package one.healthium.med

import one.primehealth.app.BaseAppConfig
import one.primehealth.app.BaseUrls
import one.primehealth.app.FirebaseAppConfig
import one.primehealth.app.Flavour
import one.primehealth.app.PlatformValues

internal fun appConfig(flavour: Flavour) =
    BaseAppConfig(
        baseUrls = BaseUrls(
            content = when (flavour) {
                Flavour.Stage -> "https://med-content-stage.web.app/"
                Flavour.Prod -> "https://med-content-prod.web.app/"
            }
        ),
        intercomApiKey = PlatformValues(
            android = "android_sdk-376cc4ff3418a1fc242d34ef12e9c3d4ff8b9fa8",
            ios = "ios_sdk-1f273098a984821e01c616b73804fe92584b24d9",
            web = "",
        ),
        intercomAppKey = "qpjbxd63",
        intercomAppName = "MED",
        amplitudeKey = when (flavour) {
            Flavour.Stage -> "1a8733087121d8457adb78414766ad73"
            Flavour.Prod -> "074d2969c773fa3a7ebb4ce4717d333b"
        },
        adaptyKey = "public_live_3IG1eFNA.I8Vs6cHML8AfFkGNxroW",
        appsflyerKey = "obcS6CH7xbbq3Kgqd3xXUH",
        appleAppId = "6739424102",
        feedbackEmail = "mediterranean@healthium.one",
        firebaseApp = when (flavour) {
            Flavour.Stage -> FirebaseAppConfig(
                applicationId = "1:702619691998:android:e26bef239cd3555e424b4f",
                apiKey = "AIzaSyCtqqG2i9Bqoo1-YTYy0OJDJ1x9mpuDJrU",
                projectId = "mediterranean-app-stage",
                storageBucket = "mediterranean-app-stage.firebasestorage.app",
                userStorageBucket = "gs://mediterranean-app-stage-users-data",
                authDomain = "mediterranean-app-stage.firebaseapp.com",
            )

            Flavour.Prod -> FirebaseAppConfig(
                applicationId = "1:694293261092:android:e2ca3ddb6d08ccc34121b1",
                apiKey = "AIzaSyCJ4vQGQBb14-XNrqZ-BywcyLWrOC8Y0Tk",
                projectId = "mediterranean-app-prod",
                storageBucket = "mediterranean-app-prod.firebasestorage.app",
                userStorageBucket = "gs://mediterranean-app-prod-users-data",
                authDomain = "mediterranean-app-prod.firebaseapp.com",
            )
        },
        appId = when (flavour) {
            Flavour.Stage -> "med_stage"
            Flavour.Prod -> "med"
        },
        oneLinkBaseUrl = "https://hltm-med.onelink.me/TOue/web",
    )

